import { Card } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Star } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Restaurant Owner",
      company: "Italian Bistro, Charlotte NC",
      photo: "https://i.pravatar.cc/150?img=1",
      quote: "Neil AI's robotics cut our labor costs by 40% and our customers love the futuristic experience. Best investment we've made.",
      metric: "40% Labor Cost Reduction",
      rating: 5
    },
    {
      name: "Michael Chen",
      role: "General Manager",
      company: "Boutique Hotel, Raleigh NC",
      photo: "https://i.pravatar.cc/150?img=13",
      quote: "The cleaning robots work overnight and our guest satisfaction scores jumped from 4.2 to 4.7 stars. Zero complaints about cleanliness in 90 days.",
      metric: "30% Faster Service",
      rating: 5
    },
    {
      name: "David Martinez",
      role: "Operations Director",
      company: "Regional Medical Center",
      photo: "https://i.pravatar.cc/150?img=12",
      quote: "Our nursing staff can finally focus on patient care instead of deliveries. The AI voice system handles appointment scheduling flawlessly.",
      metric: "50% Faster Operations",
      rating: 5
    }
  ];

  return (
    <section className="py-16">
      <div className="text-center mb-12">
        <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-4">
          Trusted By <span className="text-primary">Forward-Thinking Brands</span>
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          See what our clients are saying about their transformation
        </p>
      </div>

      <Carousel className="w-full max-w-6xl mx-auto">
        <CarouselContent>
          {testimonials.map((testimonial, index) => (
            <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
              <Card className="glass-effect border-[hsl(var(--line))] p-6 h-full flex flex-col hover:border-primary/40 transition-all duration-300">
                <div className="flex items-center gap-4 mb-4">
                  <img 
                    src={testimonial.photo} 
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full border-2 border-primary/30"
                  />
                  <div>
                    <h4 className="font-bold text-foreground">{testimonial.name}</h4>
                    <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                    <p className="text-xs text-muted-foreground">{testimonial.company}</p>
                  </div>
                </div>

                <div className="flex gap-1 mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-accent text-accent" />
                  ))}
                </div>

                <p className="text-sm text-muted-foreground mb-4 flex-grow italic">
                  "{testimonial.quote}"
                </p>

                <div className="mt-auto pt-4 border-t border-[hsl(var(--line))]">
                  <div className="text-primary font-bold text-lg">{testimonial.metric}</div>
                </div>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hover:bg-primary/20 transition-colors" />
        <CarouselNext className="hover:bg-primary/20 transition-colors" />
      </Carousel>
    </section>
  );
};

export default TestimonialsSection;
